import { render, staticRenderFns } from "./BlockAnimation.vue?vue&type=template&id=21ca72ac&scoped=true&"
import script from "./BlockAnimation.vue?vue&type=script&lang=ts&"
export * from "./BlockAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./BlockAnimation.vue?vue&type=style&index=0&id=21ca72ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca72ac",
  null
  
)

export default component.exports